import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface UseOfAuditorsSpecialistInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function UseOfAuditorsSpecialistInternalControls({ onBack, setActiveSection, controlsListSection }: UseOfAuditorsSpecialistInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Use of Auditor's Specialist"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
